import { QueryApi } from '../openapi';
import { extractValueFromQueryResponse } from 'src/helpers/utility';
import { createAuthenticatedApiClient } from './api-client';

export async function executeQuery(request) {
  try {
    request.tableName = request.tableName || '';
    request.filter = request.filter || {};

    // Get an authenticated query API instance
    const queryApi = createAuthenticatedApiClient(QueryApi);

    // Format the request according to the OpenAPI client requirements
    const apiPostQueryRequest = {
      tableName: request.table_name,
      filter: request.filter,
      data: request.data || { fields: {} },
      dynamic_parameters: request.dynamic_parameters || [],
      order: request.order,
      scale: request.scale,
      total: request.total,
      sql: request.sql,
      evol: request.evol,
      count: request.count,
      database_name: request.database_name,
    };

    // Send the request to the /query endpoint
    const response = await queryApi.query({ apiPostQueryRequest });

    if (!(response && response.success)) {
      console.error('Query execution failed:', response);
      return null;
    }

    return extractValueFromQueryResponse(response);
  } catch (err) {
    console.error('error executeQuery', err)
  }
}


export async function executeQueryReturnRawResponse(request) {
  try {
    request.tableName = request.tableName || '';
    request.filter = request.filter || {};

    // Get an authenticated query API instance
    const queryApi = createAuthenticatedApiClient(QueryApi);

    // Format the request according to the OpenAPI client requirements
    const apiPostQueryRequest = {
      tableName: request.table_name,
      filter: request.filter,
      data: request.data || { fields: {} },
      dynamic_parameters: request.dynamic_parameters || [],
      order: request.order,
      scale: request.scale,
      total: request.total,
      sql: request.sql,
      evol: request.evol,
      count: request.count,
      database_name: request.database_name,
    };

    // Send the request to the /query endpoint
    const response = await queryApi.query({ apiPostQueryRequest });

    if (!(response && response.success)) {
      console.error('Query execution failed:', response);
      return null;
    }

    return response;
  } catch (err) {
    console.error('error executeQuery', err)
  }
}